import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { IProductConfigurableSelection } from '@df/catalog/product/product';
import { WishlistItem } from '@df/session/api/wishlist/wishlist-item';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { IfBrowserDirective } from '@df/ui/common/if-browser.directive';
import { WishlistRemoveComponent } from '../../../wishlist/remove/wishlist-remove.component';
import { ProductListingConfigurableOptionsExpComponent } from '../configurable-options/product-listing-configurable-options-exp.component';
import { ProductListingWishlistToggleComponent } from '../wishlist/toggle/product-listing-wishlist-toggle.component';
import { ProductListingAddToBasketButtonExpComponent } from './button/product-listing-add-to-basket-button-exp.component';
import { ProductListingAddToBasketComponent } from './product-listing-add-to-basket.component';

@Component({
    selector: 'product-listing-add-to-basket-exp',
    templateUrl: './product-listing-add-to-basket-exp.component.html',
    styleUrl: './product-listing-add-to-basket-exp.component.scss',
    standalone: true,
    imports: [
        HrefComponent,
        ProductListingAddToBasketButtonExpComponent,
        forwardRef(() => ProductListingConfigurableOptionsExpComponent),
        IfBrowserDirective,
        ProductListingWishlistToggleComponent,
        NgClass,
        WishlistRemoveComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListingAddToBasketExpComponent extends ProductListingAddToBasketComponent {
    @Input()
    wishlistItem?: WishlistItem;

    @Input()
    wishlistCarouselItem = false;

    @Input()
    listingSize?: number;

    @Input()
    configurableSelection?: IProductConfigurableSelection;
}
